import React from 'react'
import styled, { withTheme } from 'styled-components'

import { ColoredIcon, Icon } from '../../../../../src/ui/icons/Icon.jsx'
import { rgba } from '../../../../../src/utils/dom.js'

const Wrapper = styled.div`
  background-color: ${({ theme }) => rgba(theme.colors.primary, 0.05)};
  box-shadow: inset 0px -1px 0px #EBEBEB;
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const Airport = styled.div`
  display: flex;
  flex-direction: column;

  &:last-of-type {
    text-align: right;
  }
`

const CityName = styled.span`
  ${({ theme }) => theme.fontSize('14px')};
  line-height: 22px;
  color: ${({ theme }) => theme.colors.secondaryText};
  margin-bottom: 2px;
  text-transform: uppercase;
`

const AirportCode = styled.span`
  ${({ theme }) => theme.fontSize('32px')};
  line-height: 26px;
  color: ${({ theme }) => theme.colors.primaryText};
  font-weight: 500;
`

const FlightDuration = styled.div`
  text-align: center;
  z-index: 1;
  ${({ theme }) => theme.fontSize('12px')};
  line-height: 18px;
  color: ${({ theme }) => theme.colors.primary};
`

const FlightImage = styled.div`
  width: 47px;
  height: 34px;
  position: relative;
  margin: auto;

  & > * {
    position: absolute;
    left: 0;
    top: 6px;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    border-radius: 50%;
    background-color: ${({ theme }) => rgba(theme.colors.primary, 0.2)};
    width: 32px;
    height: 32px;
    z-index: -1;
  }
`

const FlightSummary = withTheme(({
  theme,
  className,
  flightInfo
}) => {
  const {
    departure,
    arrival,
    flightDuration,
    flightIconBaseName
  } = flightInfo

  return <Wrapper className={className}>
    <Airport>
      <CityName>
        {departure.city}
      </CityName>
      <AirportCode>
        {departure.iata}
      </AirportCode>
    </Airport>

    <FlightDuration>
      {flightDuration}
      <FlightImage>
        <Icon id={`flightstatus.${flightIconBaseName}.fill`} width={49} height={26} />
        <ColoredIcon id={`flightstatus.${flightIconBaseName}.stroke`} fillColor={theme.colors.primary} width={49} height={26} />
      </FlightImage>
    </FlightDuration>

    <Airport>
      <CityName>
        {arrival.city}
      </CityName>
      <AirportCode>
        {arrival.iata}
      </AirportCode>
    </Airport>
  </Wrapper>
})

export default FlightSummary
